export const EXPIRED_STORAGE_KEY_PREFIX = "__exp_";

export interface PossibleContextData {
    cityId?: string;
    departmentId?: string;
    deliveryType?: string;
    guest_token?: string;
}
